(function () {
  function initCarousel(root) {
    var track = root.querySelector('[data-card-carousel-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-card-carousel-dots] .card-carousel__dot'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('.card-carousel__slide'));
    if (!track || slides.length < 2) return;

    var ticking = false;

    function updateActiveDot() {
      var trackRect = track.getBoundingClientRect();
      var centerX = trackRect.left + trackRect.width / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var rect = slide.getBoundingClientRect();
        var slideCenter = rect.left + rect.width / 2;
        var distance = Math.abs(slideCenter - centerX);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });

      ticking = false;
    }

    track.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateActiveDot);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  function initAll() {
    document.querySelectorAll('[data-card-carousel]').forEach(initCarousel);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
